<template>
  <!-- header -->
  <div v-if="routerPath">
    <div class="sign-content">
      <div class="sign-content-h2">{{ $t('page.supReg.stepName')[0] }}</div>
      <div class="sign-content-li">
        <p class="sign-content-title"> {{ $t('page.supReg.contentTitle')[0] }}</p>
      </div>
      <div class="sign-content-li">
        <p class="sign-content-title">{{ $t('page.supReg.contentTitle')[1] }}</p>
        <p class="sign-content-info">{{ $t('page.supReg.contentP')[1] }}</p>
      </div>
      <div class="sign-content-li">
        <p class="sign-content-title">{{ $t('page.supReg.contentTitle')[2] }}</p>
        <p class="sign-content-info">{{ $t('page.supReg.contentP')[2] }}</p>
      </div>
      <div class="sign-content-li">
        <p class="sign-content-title">{{ $t('page.supReg.contentTitle')[3] }}</p>
        <p class="sign-content-info">{{ $t('page.supReg.contentP')[3] }}</p>
      </div>
      <div class="sign-content-li">
        <p class="sign-content-title"> {{ $t('page.supReg.contentTitle')[4] }}</p>
        <p class="sign-content-info">{{ $t('page.supReg.contentP')[4] }}</p>
      </div>
    </div>
    <el-button
      class="right-btn btn"
      size="mini"
      type="primary-icon-medium"
      @click="next()"
    >
      <span>{{ $t('basicLayout.btn')[1] }}</span>
    </el-button>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  data() {
    return{
      routerPath: this.$route.path == '/maReady01',
    }
  },
  components: {},
  created() {},
  mounted() {},
  methods: {
    ...mapActions(["changeCheckPage"]),
    next() {
      this.changeCheckPage(1)
      this.$router.push({
        path:'/maReady02',
        query: {
          tempSupinfoId:this.$route.query.tempSupinfoId,
          tempOrFormalFlag:this.$route.query.tempOrFormalFlag
        }
      })
    }
  }
};
</script>

<style lang="scss" scoped>

/* content */
.sign-content {
  width: 1180px;
  height: 450px;
  background: #FFFFFF;
  margin: 20px auto;
  overflow: hidden;
  .sign-content-h2 {
    font-family: PingFangSC-Regular;
    font-size: 16px;
    color: #4A4A4A;
    letter-spacing: 0;
    line-height: 20px;
    font-weight: 600;
    margin: 18px 0px 0px 57px;
  }
  .sign-content-li {
    margin-left: 77px;
    .sign-content-title{
      padding-top: 20px;
      font-size: 14px;
      line-height: 20px;
      color: #4A4A4A;
      font-weight: 600;
    }
    .sign-content-info{
      font-size: 13px;
      line-height: 18px;
      padding-top: 4px;
      color: #4A4A4A;
      font-weight: 400;
      padding-left: 21px;
    }
  }
}


.right-btn {
  // position: absolute;
  // bottom: 20px;
  // left: 340px;
  position: relative;
  left: calc(50% - 250px);
  margin-bottom: 20px;
  width: 500px;
  height: 40px;
  background: rgba(255, 20, 47, 1);
  border-radius: 4px;
  span {
    span {
      font-size: 16px;
      font-family: PingFangSC-Semibold, PingFangSC;
      font-weight: 600;
      color: rgba(255, 255, 255, 1);
      line-height: 16px;
    }
  }
}
.right-btn:hover {
  background: rgba(255, 20, 47, 1);
}
</style>
